import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './MarketMF.css';
import { useNavigate } from "react-router-dom";

function MarketMF(props) {
    const [optionType, setOptionType] = useState('');
    let getOptionValue = props.optionValue;
    let navigate = useNavigate();

    useEffect(() => {
        if (optionType === "Overview") {
            navigate("/market/mutual-funds");
        }
        if (optionType === "Daily NAV") {
            navigate("/MutualFund/Daily-NAV");
        }
        if (optionType === "Historical NAV") {
            navigate("/MutualFund/Historical-NAV");
        }
        if (optionType === "Mutual Fund Activities") {
            navigate("/MutualFund/Mutual-Fund-Activities");
        }
        if (optionType === "Top 10 Holding") {
            navigate("/MutualFund/Top-10-Holding");
        }
        if (optionType === "SIP Calculator") {
            navigate("/Mutual-Fund-SIP-Calculator");
        }
        if (optionType === "Fund Profile") {
            navigate("/MutualFund/Fund-Profile");
        }
        if (optionType === "Mutual Fund News") {
            navigate("/MutualFund/Mutual-Fund-News");
        }
        if (optionType === "Category Return") {
            navigate("/MutualFund/Category-Return");
        }
        if (optionType === "New Fund Offer") {
            navigate("/MutualFund/New-Fund-Offer");
        }
        if (optionType === "MF Synopsis") {
            navigate("/MutualFund/MF-Synopsis");
        }
        if (optionType === "What's In & Out") {
            navigate("/MutualFund/What's-In-and-Out");
        }
        if (optionType === "Least Volatile Schemes") {
            navigate("/MutualFund/Least-Volatile-Schemes");
        } 
        if (optionType === "Dividend details") {
            navigate("/MutualFund/Dividend-Details");
        } 
        if (optionType === "Scheme Profile") {
            window.open("/Mutual-Fund/Aditya_Birla_SL_Arbitrage_Fund_(G)");
        } 
        if (optionType === "Scheme comparison") {
            navigate("/MutualFund/Scheme-Comparison");
        } 
        if (optionType === "Fund Performance") {
            navigate("/MutualFund/Fund-Performance");
        } 
    }, [optionType]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-select'>
                                    <select value={getOptionValue} onChange={(event) => { setOptionType(event.target.value) }}>
                                        <option value="Overview">Overview</option>
                                        <option value="Fund Profile">Fund Profile</option>
                                        <option value="Scheme Profile">Scheme Profile</option>
                                        <option value="New Fund Offer">New Fund Offer</option>
                                        <option value="Daily NAV">Daily NAV</option>
                                        <option value="Mutual Fund News">Mutual Fund News</option>
                                        <option value="Historical NAV">Historical NAV</option>
                                        <option value="MF Synopsis">MF Synopsis</option>
                                        <option value="Dividend details">Dividend Details</option>
                                        <option value="Mutual Fund Activities">Mutual Fund Activities</option>
                                        <option value="Top 10 Holding">Top 10 Holding</option>
                                        <option value="Least Volatile Schemes">Least Volatile Schemes</option>
                                        <option value="Scheme comparison">Scheme Comparison</option>
                                        <option value="Category Return">Category Return</option>
                                        <option value="What's In & Out">What's In & Out</option>
                                        <option value="Fund Performance">Fund Performance</option>
                                        <option value="SIP Calculator">SIP Calculator</option>
                                    </select>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MarketMF;